import { useEffect, useRef, useState } from 'react'

import { Container } from 'components/container'
import { IconFacebook } from 'components/icons/facebook'
import { IconTelegram } from 'components/icons/telegram'
import { IconWhatsapp } from 'components/icons/whatsapp'
import { Menu } from './menu'
import {
  StyledHeader,
  Logo,
  LogoContainer,
  ObservedPoint,
  ReducedNavHeight,
  Social,
  SocialToggle,
} from './styled'
import { IconShare } from 'components/icons/share'
import { IconClose } from 'components/icons/close'
import { shareUrls } from '../utils'

export const Header = () => {
  const pointRef = useRef<HTMLDivElement>(null)
  const [hasScrolled, setHasScrolled] = useState(false)
  const [isShareOpen, setShareOpen] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(([point]) => {
      setHasScrolled(!point.isIntersecting)
    })

    if (pointRef.current) {
      observer.observe(pointRef.current)
    }

    return () => observer.disconnect()
  }, [])

  return (
    <>
      <ObservedPoint ref={pointRef} />
      <StyledHeader $hasScrolled={hasScrolled}>
        <Container>
          <LogoContainer
            title="CurrentTime"
            href="/"
            $isShareOpen={isShareOpen}
          >
            <Logo />
          </LogoContainer>
        </Container>
      </StyledHeader>

      <Menu />

      <Social $isShareOpen={isShareOpen}>
        <ul>
          <li>
            <a href={shareUrls.facebook} target="_blank" rel="noreferrer">
              <IconFacebook />
            </a>
          </li>
          <li>
            <a href={shareUrls.telegram} target="_blank" rel="noreferrer">
              <IconTelegram />
            </a>
          </li>
          <li>
            <a href={shareUrls.whatsapp} target="_blank" rel="noreferrer">
              <IconWhatsapp />
            </a>
          </li>
        </ul>
        <SocialToggle onClick={() => setShareOpen(v => !v)}>
          {isShareOpen ? <IconClose /> : <IconShare />}
        </SocialToggle>
      </Social>

      {hasScrolled && <ReducedNavHeight />}
    </>
  )
}
